// Тост «игрок купил политику» внутри матча (только память клиента, на сервер
// не уходит — см. noServerSync у экшенов). Храним одну последнюю покупку:
// показ короткий, копить очередь незачем. id нужен таймеру показа, чтобы
// отличать две одинаковые покупки подряд

let nextPolicyToastId = 1;

const initialState = {
  purchase: null,
};

const policyToastReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SHOW_POLICY_PURCHASE_TOAST':
      return {
        purchase: {
          id: nextPolicyToastId++,
          playerId: action.payload.playerId,
          policy: action.payload.policy,
        },
      };
    case 'HIDE_POLICY_PURCHASE_TOAST':
      return {
        purchase: null,
      };
    // Загрузка состояния — вход в матч, просмотр записи или ресинк после
    // разрыва: покупка, лежавшая тут раньше, относится к другой партии
    case 'LOAD_STATE':
      return initialState;
    default:
      return state;
  }
};

export default policyToastReducer;
